/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * The ACCESSEligibilityResultVS codes a finished $check-eligibility submission settles on.
 */
export type AccessEligibilityResult =
  (typeof AccessEligibilityResult)[keyof typeof AccessEligibilityResult];

export const AccessEligibilityResult = {
  eligible: "eligible",
  "eligible-pending-diagnosis": "eligible-pending-diagnosis",
  "eligible-switch-participants": "eligible-switch-participants",
  "not-eligible-not-medicare": "not-eligible-not-medicare",
  "not-eligible-services": "not-eligible-services",
  "not-eligible-diagnoses": "not-eligible-diagnoses",
  "not-eligible-control-group": "not-eligible-control-group",
  "not-eligible-already-aligned": "not-eligible-already-aligned",
  "not-eligible-clinical-exclusion": "not-eligible-clinical-exclusion",
  "not-eligible-mismatch": "not-eligible-mismatch",
} as const;
